/*
* @Author: tengmaoqing
* @Date:   2018-06-14 11:57:00
* @Last Modified by:   tengmaoqing
* @Last Modified time: 2018-06-26 16:09:09
*/
import parse from 'url-parse';
let timeoutApi = {};
export const sendReport = (functionName, nowTime, spendTime, base = {}) => {
  const defaultData = [1, nowTime];
  const retCode = base.retCode;
  const myID = base.myID || 'HsbHeZuoWebApp';
  const myNode = '';
  const herID = base.herID || 'HsbApiAgent';
  const herNode = base.herNode || '119.29.42.78'; // api.huishoubao
  defaultData[2] = myID;
  defaultData[3] = myNode;
  defaultData[4] = herID;
  defaultData[5] = herNode;
  defaultData[6] = functionName;
  defaultData[7] = retCode;
  defaultData[8] = Math.min(+spendTime, 10000);
  defaultData[9] = base._bizErrCode || 0;
  defaultData[10] = base.ukey;
  if (String(retCode).indexOf('-1') !== -1) {
    try {
      const prev = timeoutApi[functionName].prev;
      const now = timeoutApi[functionName].now;
      timeoutApi[functionName].prev = nowTime;
      timeoutApi[functionName].now = '';
      if (timeoutApi[functionName] && prev && now) {
        if (Number(now) - Number(prev) <= 2) return;
      }
    } catch (error) {
      console.log(error);
    }
  }
  // 需要过滤的方法
  const filterFunctionNameList = ['/index/getlinks'];

  if (filterFunctionNameList.indexOf(functionName) === -1) {
    if (
      process.env.NODE_ENV === 'production' &&
      typeof window !== 'undefined'
    ) {
      setTimeout(() => {
        const url = `//logreport.huishoubao.com/hjxapps?${defaultData.join('=')}`;
        new Image().src = url;
      }, 300);
    }
  }
};

export const axiosResponesReport = (result = {}, base = {}) => {
  if (result.request && result.request.fromCache) {
    return;
  }

  if (!result.config) {
    return;
  }

  const now = +new Date();
  let startTime = now;
  if (result.config) {
    startTime = result.config.startTime;
  }
  const nowTime = parseInt(+new Date() / 1000);
  const urlObj = parse(result.config.url, true);
  const pid = urlObj.query.pid || 9000;
  const ukey = urlObj.query.ukey || '';
  let spendTime = now - startTime;
  do {
    result.data = result.data || {};
    base._bizErrCode = result.data._bizErrCode || 0;
    base.ukey = ukey;
    if (result.status !== 200) {
      if (result.status) {
        base.retCode = result.status;
      } else if (+spendTime < 10000) {
        base.retCode = '0';
      } else {
        if (timeoutApi[urlObj.pathname]) {
          timeoutApi[urlObj.pathname].now = nowTime;
        } else {
          timeoutApi[urlObj.pathname] = { now: nowTime };
        }
        base.retCode = result.status || -1 + `_${pid}`;
      }
      break;
    }
    if (+result.data._bizErrCode !== 0 && +result.data._errCode !== 0) {
      base.retCode = 0;
      break;
    }
    base.retCode = result.data._errCode;
  } while (0);
  sendReport(urlObj.pathname, nowTime, spendTime, base);
};



// WEBPACK FOOTER //
// ./src/helper/apiReport.js